export const mapDataForChart = rawData =>
  Object.entries(rawData).map(([date, dataItem]) => ({
    ...dataItem,
    date,
    workedHours: Math.round((dataItem.worked_minutes / 60) * 100) / 100,
    plannedHours: Math.round((dataItem.planned_minutes / 60) * 100) / 100,
    planned_minutes: undefined,
    worked_minutes: undefined,
  }));
